import * as React from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import jwtInterceptor from '../service/jwtInterceptor';
import { API_URL } from '../utils/constants';

export const EditAgenceName = ({ agence, onClose, onSuccess }) => {
    const [nom, setNom] = React.useState(agence?.nom || '');
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            await jwtInterceptor.put(`${API_URL}/agence`, {
                _id: agence._id,
                nom: nom
            });
            onSuccess();
            onClose();
        } catch (error) {
            console.error("Erreur lors de la modification de l'agence:", error);
            setError("Une erreur est survenue lors de la modification de l'agence.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
                Modifier le nom de l'agence
            </Typography>
            
            <TextField
                fullWidth
                label="Nom de l'agence"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                margin="normal"
                required
                error={!!error}
                helperText={error}
            />

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Button onClick={onClose}>
                    Annuler
                </Button>
                <Button 
                    type="submit" 
                    variant="contained" 
                    color="primary"
                    disabled={loading || !nom.trim()}
                >
                    {loading ? 'Modification...' : 'Modifier'}
                </Button>
            </Box>
        </Box>
    );
}; 